import React from 'react';
import logo from '../imagens/logo.png'; // Altere o caminho conforme necessário

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-logo">
                        <img src={logo} alt="GR Mármores" className="footer-img" />
                    </div>
                </div>
                <p className="footer-text">© 2026 GR Mármores. Todos os direitos reservados.</p>
                <p className="footer-text">Gerido Por: <a href="#" className="footer-gerido">MHSolutions</a></p>
            </div>
        </footer>
    );
};

export default Footer;
